import React, { Component } from 'react';
import Tabs from '../../components/Tab';
import AccountTiers from './AccountTiers';
import { getTabParams } from '../../common/utils'

class UserTiers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabParams: getTabParams()
        }
    }

    render () {
        const { tabParams } = this.state;
        const TiersTabList = [
             {
                 key: 'account tiers',
                 name: 'Account tiers',
                 path: '/account-tiers',
                 content: <AccountTiers />
             },
             {
                 key: 'limits',
                 name: 'Limits',
                 path: '/limits'
             },
             {
                 key: 'fees',
                 name: 'Fees',
                 path: '/fees'
             },
        ]
         return(
            <>
                <div className="main-header">
                    Tiers
				</div>
                <Tabs TabList={TiersTabList} activeTab={tabParams.tab}/>
            </>
         )
     }
    
 }
 
 export default UserTiers;